module.exports = __webpack_public_path__ + "34e5f74699ae1a63757bcdf1960f793c.svg";